module.exports = __webpack_public_path__ + "static/media/CountermovementJumpFemale.439c92ca.svg";